import * as DateUtil from '@/lib/dateutils';
import {LeadPeriodChoices} from '@/Configuration/GeneralOptions/OptionConstants';

/**
 * The Period line of a lead (consult) invoice, per the firm's Lead Invoice Period option
 * (OWA-987), or null when no Period is shown.
 *
 * - Up to Consult Date (the default): "Up to {the lead's consult date}". A lead invoice has
 *   no real start date, so this is all the period there is.
 * - Full Range: "{start} - {end}", the invoice's own dates, shown only when it has both (the
 *   behavior before OWA-987; older lead drafts carry the payment date as their start).
 * - Hide It: no Period.
 *
 * A finalized lead invoice freezes this text in its snapshot (`display.leadPeriod`), so a
 * later change to the option or the consult date never changes it.
 *
 * @param {string | null | undefined} choice - the option value; anything unknown means the default
 * @param {{startDate?: Date | null, endDate?: Date | null}} invoice
 * @param {Date | null | undefined} consultDate - the lead's initial consult date
 * @returns {string | null}
 */
export function leadPeriodText(choice: string | null | undefined,
                               invoice: {startDate?: Date | null, endDate?: Date | null},
                               consultDate: Date | null | undefined): string | null {
    const format = (date: Date) => DateUtil.formatDate(date, false, false, false) || '';

    switch (choice) {
        case LeadPeriodChoices.HIDE:
            return null;
        case LeadPeriodChoices.FULL_RANGE:
            return invoice.startDate && invoice.endDate
                   ? `${format(invoice.startDate)} - ${format(invoice.endDate)}`
                   : null;
        default:
            return consultDate ? `Up to ${format(consultDate)}` : null;
    }
}
